/**
 * Request builders for the stats resource.
 * Each function returns a plain RequestInfo object for use with requestManager.request.
 */

export function getStats() {
  return {
    url: '/api/stats',
    options: {
      isMetaRequest: true,
    },
  };
}
